import { PageContainer } from "@/components/page-container";
import { Tab } from "@renderbus/ui";
import { ConsumerOverview } from "@/pages/consumption/view/consumer-overview";
import { Billing } from "@/pages/consumption/view/billing";
import { BillingDetails } from "@/pages/consumption/view/billing-details";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo } from "react";
import { isEn } from "project-config/utils/env";
import { safeSetTitle } from "project-config/utils/title";
import { ConsumeProvider, useConsumeStore } from "./store/ConsumeStore";
import { BillTabTypeEnum } from "./constants";
import { useGlobalStore } from "@/store/GlobalStore";

export function ConsumptionView() {
  const { t } = useTranslation("center");
  const searchParams = queryString.parse(window.location.search);
  const type = searchParams.type as string;
  const { activeKey, setActiveKey } = useConsumeStore();
  const { is88StudioUser, isSubAccount } = useGlobalStore();
  const is88StudioSubAccount = is88StudioUser && isSubAccount;
  useEffect(() => {
    isEn() &&
      safeSetTitle(
        "Consumption on Cloud Rendering Web Console - Fox Renderfarm"
      );
  }, []);

  const tabsList = useMemo(() => {
    const allTabs = [
      {
        label: t("consumption_overview_tab"),
        children: <ConsumerOverview />,
        key: BillTabTypeEnum.ConsumerOverview,
      },
      {
        label: t("consumption_bill_tab"),
        children: <Billing />,
        key: BillTabTypeEnum.Billing,
      },
      {
        label: t("consumption_detail_tab"),
        children: <BillingDetails />,
        key: BillTabTypeEnum.BillingDetails,
      },
    ];
    if (is88StudioSubAccount) {
      return allTabs.filter(
        (tab) => tab.key === BillTabTypeEnum.BillingDetails
      );
    }
    return allTabs;
  }, [t, is88StudioSubAccount]);

  useEffect(() => {
    if (is88StudioSubAccount) {
      setActiveKey(BillTabTypeEnum.BillingDetails);
    }
  }, [is88StudioSubAccount, setActiveKey]);

  return (
    <PageContainer>
      <Tab
        tabsList={tabsList}
        activeKey={type || activeKey}
        onTabClick={(key) => {
          if (!type) {
            setActiveKey(key as BillTabTypeEnum);
            return;
          }
          delete searchParams.type;
          delete searchParams.billStartTime;
          window.location.search = queryString.stringify(searchParams, {
            skipNull: true,
          });
        }}
      />
    </PageContainer>
  );
}

export function Consumption() {
  return (
    <ConsumeProvider>
      <ConsumptionView />
    </ConsumeProvider>
  );
}
